import React, { useState } from 'react';
import './AGIndustries.css';

const AGIndustries = () => {
  const [animar, setAnimar] = useState(false);
  
  // Estado para controlar qué menú está desplegado (null = ninguno)
  const [menuActivo, setMenuActivo] = useState(null);

  const ejecutarAnimacionYLink = () => {
    setAnimar(true);
    setTimeout(() => {
      setAnimar(false);
    }, 800);
  };

  return (
    <div className={`sx-wrapper ${animar ? 'efecto-salida' : ''}`}>
      <nav className="sx-nav">
        <div className="sx-nav-content">
          <div className="sx-logo">
             <img
              src="/FAVICON.PNG"
              alt="Logo"
              className="sx-logo-img"
             />
          </div>

           <div className="sx-nav-right">
    </div>
  </div>
</nav>

      {/* SECCIÓN 1: RENDER */}
      <section className="sx-hero">
        <div className="sx-bg-container">
          <video src="/Render.mp4" className="sx-bg-media" autoPlay loop muted playsInline />
          <div className="sx-overlay"></div>
        </div>
        <div className="sx-hero-content">
          <h1>AG Industries Limited&nbsp;<sup className="sx-tm">™</sup></h1>
          <p>Advanced technology for the world, based in México.</p>
          <button className="sx-btn-ghost" onClick={ejecutarAnimacionYLink}>
            <span>Discover Atlas</span>
          </button>
        </div>
      </section>

      <footer className="sx-footer">
        <div className="sx-footer-content">
            <p className="sx-copyright sx-footer__copy">AG Industries Limited ™ - © All rights reserved.
    </p>
          <nav className="sx-footer-links">
            <a href="#"></a>
            <a href="#"></a>
            <a href="#"></a>
            <a href="#"></a>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default AGIndustries;